module.exports = __webpack_public_path__ + "static/media/ring2.273b906f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/ring2.mp3
// module id = 6489
// module chunks = 39